import { render, staticRenderFns } from "./PreGeracaoContratoPropostaTab.vue?vue&type=template&id=5ff96ad6"
import script from "./PreGeracaoContratoPropostaTab.vue?vue&type=script&lang=js"
export * from "./PreGeracaoContratoPropostaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports